import React from 'react';
import { Clock, AlertTriangle, CheckCircle2 } from 'lucide-react';

/**
 * FreshnessBadge — displays data freshness status with color-coded badge.
 *
 * Thresholds:
 *   - Green (fresh): >70% of spend from last 24 months
 *   - Amber (aging): 40-70% from last 24 months
 *   - Red (stale): <40% from last 24 months
 */
function FreshnessBadge({ freshnessPct, mostRecentDate, asOfQuery, compact = false }) {
  if (freshnessPct == null) {
    return null;
  }

  const pct = Math.round(freshnessPct * 100);

  let status, icon, className;
  if (pct >= 70) {
    status = 'Fresh';
    icon = <CheckCircle2 size={compact ? 10 : 12} />;
    className = 'vca-freshness-badge--fresh';
  } else if (pct >= 40) {
    status = 'Aging';
    icon = <Clock size={compact ? 10 : 12} />;
    className = 'vca-freshness-badge--aging';
  } else {
    status = 'Stale';
    icon = <AlertTriangle size={compact ? 10 : 12} />;
    className = 'vca-freshness-badge--stale';
  }

  const tooltipParts = [
    `${pct}% of spend from last 24 months`,
  ];
  if (mostRecentDate) {
    const dateStr = new Date(mostRecentDate).toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric',
    });
    tooltipParts.push(`Most recent PO: ${dateStr}`);
  }
  if (asOfQuery) {
    const queryStr = new Date(asOfQuery).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    tooltipParts.push(`Data as of ${queryStr}`);
  }

  return (
    <span
      className={`vca-freshness-badge ${className} ${compact ? 'vca-freshness-badge--compact' : ''}`}
      title={tooltipParts.join('\n')}
    >
      {icon}
      <span>{compact ? `${pct}%` : `${status} (${pct}%)`}</span>
    </span>
  );
}

export default FreshnessBadge;
